import * as React from "react";
const IconSessionTime = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.9863 10.4924H10.3363C10.3363 10.7705 10.5131 11.0177 10.7762 11.1075L10.9863 10.4924ZM11.6363 6.28888C11.6363 5.92989 11.3453 5.63888 10.9863 5.63888C10.6273 5.63888 10.3363 5.92989 10.3363 6.28888H11.6363ZM13.2378 11.9483C13.5776 12.0643 13.947 11.8829 14.063 11.5432C14.1791 11.2035 13.9977 10.8341 13.658 10.718L13.2378 11.9483ZM11.6363 10.4924V6.28888H10.3363V10.4924H11.6363ZM10.7762 11.1075L13.2378 11.9483L13.658 10.718L11.1964 9.87732L10.7762 11.1075ZM18.5416 10.4924C18.5416 14.7915 15.1442 18.2495 10.9863 18.2495V19.5495C15.8918 19.5495 19.8417 15.4796 19.8417 10.4924H18.5416ZM10.9863 18.2495C6.82843 18.2495 3.43101 14.7915 3.43101 10.4924H2.13101C2.13101 15.4796 6.08087 19.5495 10.9863 19.5495V18.2495ZM3.43101 10.4924C3.43101 6.19332 6.82843 2.73533 10.9863 2.73533V1.43533C6.08087 1.43533 2.13101 5.50531 2.13101 10.4924H3.43101ZM10.9863 2.73533C15.1442 2.73533 18.5416 6.19332 18.5416 10.4924H19.8417C19.8417 5.50531 15.8918 1.43533 10.9863 1.43533V2.73533Z"
      fill="#1C1C2C"
    />
  </svg>
);
export default IconSessionTime;
